import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUser } from '@/context/UserContext';

export const useProtectedRoute = () => {
	const { user, loading } = useUser();
	const router = useRouter();

	useEffect(() => {
		// Don't redirect while still loading
		if (!loading && !user) {
			router.replace('/login');
		}
	}, [user, loading, router]);

	return { user, loading };
};
